<template>
  <div>
    <!--pc view-->
    <div class="fv cc" v-show="!mobileView">
        <div class="fh cc" style="width: 100vw; height:6vh ;background:#005A9F" >
        <div class="fh cc" style="width: 700px; height:6vh" >
            <div class="fh lc" style="width: 30%" title="Home" >
                <img id="iconHome"  @click= "btnHome" style="height: 25px" :src="imagenProducto"  />
            </div>
            <div class="fh rc" style="width: 70%; height:6vh">
            <span class="labels" style="padding-left: 25px; padding-right: 40px"  @click= "btnCliente">{{ nombreCliente }}</span> 
            <div class="globe1" v-show='itemsCarrito!=0' @click= "btnCarrito">
                {{itemsCarrito}}
            </div>
            <img  id="iconCarrito" class="icon" @click= "btnCarrito"  src="/dist/carrito.svg" />
            <div class="dropdown" @mouseover='showDropUsuario' @mouseleave='hideDropUsuario'>
                <span class="labels" style="padding-left: 25px; padding-right: 10px">{{nombreUsuario}}</span>
                <div id="avatarGlobe">
                <span id="avatarChar" style="color:#4969B2; font-weight: 700; font-size: 18px ">{{letraNombreUsuario}}</span>
                </div>
                <div  class="dropdown-content-b"  v-show='dropUsuario' >
                <router-link :to="{name: 'configuracion'}">Cambiar contraseña</router-link>
                <div  class="separator-menu" >  </div>
                <a href="#cerrar" @click="cerrarSesion">Cerrar sesión</a>
                </div>
            </div>
            </div>
        </div>
        </div>
        <div  class="separator" >  </div>  
    </div>

    <!--mobile view-->
    <div class="fv cc" v-show="mobileView">
        <div class="fh cc" style="width: 100vw; height:40px; position: fixed; top: 0px; background:#005A9F" >
          <div class="fh lc" style="width: 25vw; height: 100%">
              <img id="iconHome" style="margin-left: 20px" :src="iconMenu" @click= "btnMenu"/>
          </div>  
          <div class="fh cc" style="width: 50vw; height: 100%">
              <img id="iconHome"  src="/dist/logo_header3.png"/>
          </div>  
          <div class="fh rc" style="width: 25vw; height: 100%;" >
              <div class="globe1" v-show='itemsCarrito!=0' @click= "btnCarrito">
                {{itemsCarrito}}
              </div>
              <img id="iconHome" style="margin-right: 10px" src="/dist/carrito.svg"  @click= "btnCarrito">
              <img id="iconHome" style="margin-right: 20px" src="/dist/icon-home.png" @click= "btnHome" >
          </div>  
        </div>
      <div  class="separator" >  </div>  
    </div>

  </div>
</template>


<script>
import axios from 'axios'

export default {
  name: 'sales-header',


  data () {
    return {
      dropPedidos: false,
      dropUsuario: false,
      //imagenProducto: null,
      iconMenu: '/dist/icon-menu.png',
      menuVisible: false,
      mobileView:false
    }
  },


  computed: {
    itemsCarrito () {
      return this.$store.state.pedido.carrito.length;
    },
    nombreUsuario() {
      if (this.$store.state.user.usuario.EsEmpleado) {
        return this.$store.state.user.usuario.EmpleadoNombre;
      } 
      else {
        return this.$store.state.user.usuario.ClienteNombre;
      }  
    },
    letraNombreUsuario() {
      if (this.$store.state.user.usuario.EsEmpleado) {
        return this.$store.state.user.usuario.EmpleadoNombre.charAt(0);
      } 
      else{
        return this.$store.state.user.usuario.ClienteNombre.charAt(0);
      }  
    },
    nombreCliente() {
      if ((this.$store.state.user.usuario.EsEmpleado) && (this.$store.state.user.cliente != null)) {
        return this.$store.state.user.cliente.Nombre;  
      } 
      else {
        return "";
      }  
    },
    imagenProducto() {
      if (this.$store.state.user.usuario.ArchivoLogoUrl != null) {
        return this.$store.state.user.usuario.ArchivoLogoUrl
      }
      else {
        return '/dist/logo_header3.png'
      }
    } 
  },


  methods: {

    onResize() {
      if (window.innerWidth > 600) 
      {
        this.mobileView=false;
      }
      else 
      {
        this.mobileView=true;
      }
    },

    
    btnCarrito() {
      if (this.itemsCarrito > 0) {
        if (this.$store.state.pedido.tipoOperacion == 'pedido') {
          this.$router.push({ name: 'pedido' });
        }
        else if (this.$store.state.pedido.tipoOperacion == 'presupuesto') {
          this.$router.push({ name: 'presupuestos' });
        }
        else if (this.$store.state.pedido.tipoOperacion == 'devolucion') {
          this.$router.push({ name: 'devoluciones' });
        }
      }
    },

    btnCliente() {
      this.$router.push({ name: "clientes" });
    },

    btnHome() {
      this.$router.push({ name: 'home' });
    },

    btnMenu() {
      if (this.$store.state.popup.popupMenu) {
        this.$store.commit('popup/closeMenu');
        this.iconMenu = '/dist/icon-menu.png';
      } 
      else {
        this.$store.commit('popup/openMenu');       
        this.iconMenu = '/dist/icon-close.png';
      }
    },

    showDropPedidos() {
      this.dropPedidos = true;
    },

    hideDropPedidos() {
      this.dropPedidos = false;
    },

    showDropUsuario() {
      this.dropUsuario = true;
    },

    hideDropUsuario() {
      this.dropUsuario = false;
    },

    cerrarSesion() {
        this.$store.commit("loader/start");
        axios.put('/WebSalesLogin',{},{
         headers:{
                    Token:        this.$store.state.user.usuario.Token,
                    ClientSecret: this.$store.state.entorno.clientSecret,
                    EmpresaId:    this.$store.state.entorno.idEmpresa
                  }
         }
        ).then((response) => {
           this.$store.commit("loader/stop");
           this.$access('any')
           this.$store.commit('user/deleteUser');
           this.$store.commit('user/deleteCliente');
           this.$store.commit('user/deleteEmpresas');
           this.$store.commit('user/deleteResponseLogin');
           this.$store.commit('user/deleteImagenLogo');
           this.$store.commit('user/deleteImagenHeader');
           this.$store.commit('pedido/delete');
           this.$store.commit('entorno/delete');
           this.$router.push({ name: "login" });
           if (response.data.Code != 0)
           {
             alert(response.data.Message);
           }

        },(error) => { 
            this.$store.commit("loader/stop");
            this.$access('any')
            this.$store.commit('user/deleteUser');
            this.$store.commit('user/deleteCliente');
            this.$store.commit('user/deleteEmpresas');
            this.$store.commit('user/deleteResponseLogin');
            this.$store.commit('user/deleteImagenLogo');
            this.$store.commit('user/deleteImagenHeader');
            this.$store.commit('pedido/delete');
            this.$store.commit('entorno/delete');
            this.$router.push({ name: "login" });
            alert(error); 
        })
    },

    cambiarPass() {
      this.$router.push({ name: "configuracion" });
    },

  },


  mounted() {
    this.onResize()
  },

  created() {
    window.addEventListener('resize', this.onResize)
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  }

   

}

</script>


<style scoped>

.dropdown {
    height: 40px;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.dropdown-content:before {
    content:"";
    position: absolute;
    right: 120px;
    top: -10px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 10px 10px 10px;
    border-color: transparent transparent #ffffff transparent;
    z-index:9999;
}

.dropdown-content {
  top: 40px;
  position: absolute;
  background-color: #ffffff;
  min-width: 160px;
  border-radius: 5px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

.dropdown-content a:hover{
  cursor: pointer;
  color: #000000;
}

.dropdown-content a {
    color: #555555;
    padding: 12px 16px;
    text-decoration: none;
    display: block;
    font-size: 12px;
    font-weight: 400;
}

/* ------------------------------------------------------ */


.dropdown-content-b:before {
    content:"";
    position: absolute;
    right: 80px;
    top: -10px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 10px 10px 10px;
    border-color: transparent transparent #ffffff transparent;
    z-index:9999;
}


.dropdown-content-b {
    margin-top: 110px;
    margin-left: 30px;
    position: absolute;
    background-color: #ffffff;
    min-width: 160px;
    border-radius: 5px;
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
    z-index: 1;
}

.dropdown-content-b a:hover{
  cursor: pointer;
  color: #000000;
}

.dropdown-content-b a {
    color: #555555;
    padding: 12px 16px;
    text-decoration: none;
    display: block;
    font-size: 12px;
    font-weight: 400;
}


    #header {
      width: 700px;
      height: 40px;
      background-color: #005A9F;
      display: flex;
      flex-direction: row;
      align-items: center;
    }

    .labels {
        /*padding-right: 40px;
        padding-left: 25px;*/
        vertical-align: middle;
        font-size: 12px;
        color: white;
    }

    #iconHome{
      height: 18px;
    }

    .separator {
        width: 100%;
        height: 1px;
        background-color: #136AAA;
    }


    .separator-menu {
        width: 100%;
        height: 1px;
        background-color: #dddddd;
    }


#avatarGlobe{
  width: 28px;
  height: 28px;
  background:#dddddd;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
}


#menuPedido:hover { cursor: pointer; }
#iconCarrito:hover { cursor: pointer; }
#carritoItemsGlobe:hover { cursor: pointer; }
#usuario:hover { cursor: pointer; }
#avatarGlobe:hover { cursor: pointer; }
#iconHome:hover { cursor: pointer; }
.menu:hover { cursor: pointer; }

</style>



// WEBPACK FOOTER //
// src/components/views/header.vue